import React, { useState } from 'react';
import { Brain, Check, ChevronRight } from 'lucide-react';
import T from 'Components/Helpers/translate';

type Props = {
	// Accumulated reasoning text (the parent merges the streamed snapshots).
	thinking: string;
	isStreaming: boolean;
	// Optional controlled expand state. When provided, the parent owns it (used for
	// the live streaming block). Otherwise the block owns its own state, seeded once
	// from `defaultExpanded` — this lets a finished block keep the expand choice made
	// while it was streaming without following later resets of the live state.
	expanded?: boolean;
	onToggle?: (next: boolean) => void;
	defaultExpanded?: boolean;
};

const ThinkingBlock = ({ thinking, isStreaming, expanded: expandedProp, onToggle, defaultExpanded }: Props) => {
	const [internalExpanded, setInternalExpanded] = useState(defaultExpanded ?? false);
	const expanded = expandedProp ?? internalExpanded;
	const toggle = () => {
		const next = !expanded;
		onToggle?.(next);
		if (expandedProp === undefined) setInternalExpanded(next);
	};

	return (
		<div className="pr-think">
			<button type="button" className="pr-think-summary" onClick={toggle} aria-expanded={expanded}>
				<Brain
					style={{ width: 14, height: 14 }}
					className={isStreaming ? 'pr-think-summary-icon pr-think-pulse' : 'pr-think-summary-icon'}
				/>
				<span className="pr-think-summary-text">
					{isStreaming ? T('assistant.thinking') : T('assistant.thought')}
				</span>
				<ChevronRight
					style={{ width: 14, height: 14 }}
					className={expanded ? 'pr-think-chev pr-think-chev-open' : 'pr-think-chev'}
				/>
			</button>
			{expanded && (
				<div className="pr-think-detail">
					<div className="pr-think-full">{thinking}</div>
					{!isStreaming && (
						<div className="pr-think-done">
							<Check style={{ width: 13, height: 13 }} />
							<span>{T('assistant.thinkingDone')}</span>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default ThinkingBlock;
